/**
 * Shared viewport observer for product card galleries.
 * One IntersectionObserver for all galleries (Horizon SlideshowViewportObserver pattern).
 */
export class ProductCardGalleryViewportObserver {
  static #instance: ProductCardGalleryViewportObserver | null = null;

  #observer: IntersectionObserver | null = null;

  static getInstance(): ProductCardGalleryViewportObserver {
    if (!this.#instance) {
      this.#instance = new ProductCardGalleryViewportObserver();
    }
    return this.#instance;
  }

  observe(gallery: HTMLElement): void {
    if (!this.#observer) {
      this.#observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            const target = entry.target as HTMLElement;
            if (entry.isIntersecting) {
              target.setAttribute('in-viewport', '');
            } else {
              target.removeAttribute('in-viewport');
            }
          }
        },
        { rootMargin: '100px' }
      );
    }

    this.#observer.observe(gallery);
  }

  unobserve(gallery: HTMLElement): void {
    this.#observer?.unobserve(gallery);
    gallery.removeAttribute('in-viewport');
  }
}
